import {app} from '../../../app';

export const handleMFEMessages = (payload, id = 'app') => {
    switch (payload.subtype) {
        case 'success':
            // Supress Vue.toast for successful logout message: "You have been logged out successfully."
            if (payload.data.includes('logged out')) {
                break;
            }
            app.$toast.success(payload.data, {id: `${id}_success`});
            break;
        case 'error':
            app.$toast.error(payload.data, {id: `${id}_error`});
            break;
        case 'warning':
            app.$toast.warning(payload.data, {id: `${id}_warning`});
            break;
        default:
            app.$toast.info(payload.data, {id: `${id}_info`});
    }
}